var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box main"},[_c('div',{staticClass:"level-item header-section"}),_c('div',{staticClass:"columns"},[_c('div',{staticClass:"column"},[_c('div',{staticClass:"box"},[_c('customer-left-panel')],1)]),_c('div',{staticClass:"column is-9"},[_c('router-view')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }